import React, { useState, useEffect } from "react";
import "../styles/App.css";
import ImageCarousel from "../components/ImageCarousel";
import "bootstrap/dist/css/bootstrap.min.css";
import Program from "../components/Program";
import Spinner from "../components/Spinner";
import PageMeta from "../components/PageMeta";
import { Link } from "react-router-dom";
import Ribbon from "../components/Ribbon";


function App() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const onLoad = () => {
            setIsLoading(false);
        };

        window.addEventListener("load", onLoad);

        // Añadimos un temporizador para asegurarnos de que el spinner se oculte después de un tiempo determinado, incluso si el evento 'load' no se dispara correctamente en Safari
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000); // Cambia este valor según la duración que desees

        return () => {
            window.removeEventListener("load", onLoad);
            clearTimeout(timer);
        };
    }, []);

    return (
        <main id="main-content" className="App">
            <PageMeta title="Private Chef & Catering in Tampa" description="Private dining, catering, and pop-up dinner experiences by Chef Miguel Bravo in Tampa Bay." />
            <section className="home-hero" aria-label="Culinary experiences by Miguel Bravo">
                <ImageCarousel />
                <div className="home-hero-shade" />
                <div className="home-hero-content">
                    <span className="hero-eyebrow">Private chef · Catering · Pop-up dinners</span>
                    <h1 className="hero-title">A table worth remembering.</h1>
                    <p>Bold flavors, thoughtful details, and culinary experiences made to be remembered.</p>
                    <Link
                        className="contact-button"
                        to="/contact"
                    >
                        Plan your experience
                    </Link>
                </div>
                <div className="hero-edition" aria-hidden="true">
                    <span>01</span>
                    <i />
                    <span>Tampa Bay</span>
                </div>
                <div className="hero-ghost-word" aria-hidden="true">BRAVO</div>
                <span className="hero-scroll" aria-hidden="true">Discover</span>
            </section>

            <Ribbon />
            <Program />
            {isLoading && <Spinner />}
        </main>
    );
}

export default App;
